import { storeToRefs } from 'pinia'
import { useToastStore } from '~/stores/toast'

export function useToast() {
    const { visible, message, variant } = storeToRefs(useToastStore())

    const show = () => {
        visible.value = true
    }

    const hide = () => {
        visible.value = false
    }

    const toast = (m: string, v: string = 'success') => {
        message.value = m
        variant.value = v
        show()
    }

    return { show, hide, toast }
}
